
export default function Education() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="order-2 lg:order-1">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-[#F8F8F8]">
              <img
                src="https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/b7955ccec0a2946b19e25c856eb65b29.png"
                alt="Proper Sleep Position"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2">
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.15em] text-[#8A8A8A] mb-4 sm:mb-6">
              THE SCIENCE
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight mb-4 sm:mb-6">
              Why Nasal Breathing Matters
            </h2>
            <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed mb-6 sm:mb-8">
              Breathing through your nose filters air, regulates temperature, and increases oxygen absorption. 
              It's not just about aesthetics—it's about optimizing your body's most fundamental function.
            </p>
            <div className="space-y-4 sm:space-y-6">
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black/5 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-lg sm:text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-black mb-1 sm:mb-2">Better Oxygen Flow</h3>
                  <p className="text-xs sm:text-sm text-[#6B6B6B]">Nasal breathing increases nitric oxide production, improving oxygen delivery to your cells.</p>
                </div>
              </div>
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black/5 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-lg sm:text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-black mb-1 sm:mb-2">Reduced Snoring</h3>
                  <p className="text-xs sm:text-sm text-[#6B6B6B]">Keeping your mouth closed during sleep naturally reduces snoring and improves sleep quality.</p>
                </div>
              </div>
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-black/5 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-lg sm:text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-black mb-1 sm:mb-2">Facial Structure Support</h3>
                  <p className="text-xs sm:text-sm text-[#6B6B6B]">Proper jaw positioning during sleep helps maintain and enhance your natural facial definition.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
